'use strict';

module.exports = /[&<>]/g;